import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Badge, Dropdown, Divider, Button, Spin} from 'antd';
import {BellOutlined} from '@ant-design/icons';
import {io} from 'socket.io-client';
import {
    useGetNotificationListQuery,
    useReadNotificationMutation,
    useReadAllNotificationMutation
} from "../slices/rootApiSlices/notificaitonsApiSlice";
import {addNotification, setNotifications, markAsRead} from "../slices/notificationSlice";

const UserNotification = () => {


    const {user} = useSelector((state) => state.auth);
    const {notifications} = useSelector((state) => state.notifications);
    const {data, refetch} = useGetNotificationListQuery(user?.token);
    const dispatch = useDispatch();
    const token = user?.token;

    const [readNotification, {isLoading}] = useReadNotificationMutation();
    const [readAllNotifications, {isLoading: isLoadingAll}] = useReadAllNotificationMutation();

    useEffect(() => {
        if (data?.data) {
            dispatch(setNotifications(data?.data));
        }
    }, [data, dispatch]);

    useEffect(() => {
        if (user && token) {
            const socket = io('https://live.myoctoopidev.com', {
                query: {
                    'x-access-token': token,
                }
            });

            socket.on('notification', (notification) => {
                dispatch(addNotification(notification));
            });

            return () => {
                socket.disconnect();
            };
        }
    }, [user, token, dispatch]);

    const handleMarkAsRead = async (_id) => {
        try {
            await readNotification({token, id: _id});
            refetch();
            dispatch(markAsRead(_id));
        } catch (err) {
            console.error('Bildirim okundu olarak işaretlenirken hata:', err);
        }
    };

    const handleMarkAllAsRead = async () => {
        try {
            await readAllNotifications(token);
            refetch();
        } catch (err) {
            console.error('Tüm bildirimler okunmuş olarak işaretlenirken hata:', err);
        }
    };

    // Bildirimleri görünür hale getiriyoruz
    const visibleNotifications = notifications;

    const items = visibleNotifications.length > 0
        ? visibleNotifications.map((notification, index) => ({
            key: notification._id ? notification._id.toString() : `notification-${index}`,
            label: (
                <>
                    <div
                        onClick={() => handleMarkAsRead(notification._id)}
                        style={{
                            fontWeight: notification.isRead ? 'normal' : 'bold',
                            fontSize: '13px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            maxWidth: '250px',
                            wordWrap: 'break-word',
                        }}
                    >
                        <div>
                              {notification.message || `Threshold: ${notification.threshold_value}`}
                        </div>
                        {isLoading && notification._id && (
                            <Spin size="small" style={{marginLeft: '10px'}}/>
                        )}
                    </div>
                    {index < visibleNotifications.length - 1 && <Divider style={{margin: '2px 5px'}}/>}
                </>
            ),
        }))
        : [{
            key: '0',
            label: (
                <div style={{fontSize: '14px', textAlign: 'center'}}>
                    <h4>Kayıtlı bildirim bulunamadı.</h4>
                </div>
            ),
        }];

    items.push({
        key: 'markAllAsRead',
        label: (
            <div style={{textAlign: 'center'}}>
                <Button disabled={notifications.length === 0} type="link" onClick={handleMarkAllAsRead}
                        loading={isLoadingAll}>
                    Tümünü okundu olarak işaretle
                </Button>
            </div>
        ),
    });

    const unreadCount = notifications.filter(notification => !notification.isRead).length;

    return (
        <div style={{marginRight: '13px', cursor: 'pointer'}}>
            <Dropdown
                menu={{
                    items,
                    style: {
                        maxHeight: '300px',
                        overflowY: 'auto'
                    }
                }}
                trigger={['click']}
            >
                <Badge size="small" count={unreadCount} offset={[3, 0]}>
                    <BellOutlined style={{color: 'white', fontSize: 16}}/>
                </Badge>
            </Dropdown>
        </div>
    );
};

export default UserNotification;
